/* Extracted from snippets/fon-klaviyo-force-oos.liquid (was an inline parser-time jQuery block).
   Loaded with `defer` from the same file, so it runs after footer jQuery. */
(function () {
      if (typeof jQuery === 'undefined') return;
      jQuery(function ($) {
        $(document).on('click', '#fon-twostrong-oos-button', function (e) {
          e.preventDefault();
          if (!$.magnificPopup) return;
          $.magnificPopup.open({
            items: { src: '#klaviyo-oos-twostrong' },
            type: 'inline',
            /* Same scroll lock as the PDP opener — the page kept scrolling
               behind the popup without it. */
            callbacks: {
              open:  function () { document.documentElement.classList.add('ts-modal-lock'); },
              close: function () { document.documentElement.classList.remove('ts-modal-lock'); }
            }
          });
        });
      });
    })();
